<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  .box{width: 1180px;margin:auto;}
  i{font-size: 24px;}
  .recommendation{margin-top: 24px;height: 30px;
    span{font-size: 18px;}
  }
  .swipergroup{margin-top: 20px;}
  .mining{margin-top: 44px;height: 30px;
  span{font-size: 18px;font-weight: 600;float: left;}}
  ul{width: 1160px;margin-left: -30px;}
  li:nth-child(1) .first .second{font-size: 18px;}
  .search{margin-left: -30px;margin-bottom: 20px;}
}
@media screen and (max-width: @max-screen)
{
  .search{margin-left: 0;margin-bottom: 20px;}
  .box{width: 100%;margin:auto;}
  i{font-size: 20px;}
  .recommendation{width: 94%;margin: 5% auto;
    span{font-size: 16px;}
  }
  .mining{width: 94%; margin:3% auto;display: flex;}
  ul{width: 100%;margin: 0; padding: 0;font-size: 14px;}
  li:nth-child(1) .first .second{font-size: 14px;}
}
.hzxmKYXMList{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;color: rgb(25, 159, 248);}
.recommendation{
  span{font-weight: 600;float: left;}
}


ul{list-style: none;}
li:nth-child(1) {background-color: #ECF6FF;line-height: 28px;display: flex;
  .first{width: 200px;} .second{width:160px;} .third{width: 160px;}
  .fourth{width: 250px;} .fifth{width: 165px;}
  .sixth{width: 220px;}
}
li:nth-child(n+2){height: 30px;border-bottom: 1px solid #f0f0f0;display: flex;padding-top: 10px;cursor: pointer;
  .first{width: 200px;text-align: left;margin-left: 16px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .second{width: 160px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .third{width: 150px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .fourth{width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .fifth{width: 165px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .sixth{width: 220px;text-align: left;margin-left: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
}
li:nth-child(n+2):hover{color: #199ff8}
.el-button{width: 200px;font-size: 16px;border-radius: 5px;background-color: #ECF6FF;margin-top: 30px;}
</style>

<template>
  <div class="hzxmKYXMList">
    <div class="box">
      <div class="recommendation">
        <i class="iconfont icon-rementuijian" />
        <span>热门推荐 / Popular recommendation</span>
      </div>
      <div class="swipergroup">
        <SwiperGroup :swiperGroupList="swiperGroupList" @clickSwiper="goDetails"></SwiperGroup>
      </div>
      <div class="mining">
        <i class="iconfont icon-xiangmuwenjian" />
        <span>矿权推介 / Mining right promotion</span>
      </div>
      <div class="search">
        <SearchBarKYQTJ @searchdata="search"></SearchBarKYQTJ>
      </div>
      <ul>
        <li>
          <div class="first">矿业名称</div>
          <div class="second">矿业权类型</div>
          <div class="third"   v-if='ifShowFlag'>合作意向</div>
          <div class="fourth"  v-if='ifShowFlag' style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">项目优势</div>
          <div class="fifth"  v-if='ifShowFlag'>发布时间</div>
          <div class="sixth"  v-if='ifShowFlag'>资源量</div>
        </li>
        <li v-for="(item,index) in items" :key="index" @click="goDetailsP(item)">
          <div class="first"> {{ item.title }} </div>
          <div :title="item.kyqlx" class="second"> {{ item.kyqlx}} </div>
          <div class="third"  v-if='ifShowFlag'> {{ item.hzyx }} </div>
          <div class="fourth" :title="item.xmys"  v-if='ifShowFlag'> {{ item.xmys }} </div>
          <div class="fifth"  v-if='ifShowFlag'> {{ item. addtime * 1000 | formatDate() }} </div>
          <div class="sixth"  v-if='ifShowFlag'> {{ item.zyl }} </div>
        </li>
      </ul>
      <el-button @click="getOthers" :disabled="moreLength <= 0">加载更多</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 矿权推介列表页面
 */
import SwiperGroup from '../assembly/SwiperGroup.vue'
import SearchBarKYQTJ from '../assembly/SearchBarKYQTJ.vue'
import filters from '../method/filter.js'

export default {
  name: '',
  components:
  {
    SwiperGroup,
    SearchBarKYQTJ
  },
  mixins: [filters],
  data()
  {
    return {
      swiperGroupList: [],
      projectsList: [],
      num: null,
      items: [],
      moreLength: null,
      ifShowFlag: true
    }
  },
  created()
  {
    this.getKyxm()
    this.search(['', ''])
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods:
  {
    getKyxm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 129, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupList = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, kqqs: item.kqqs, kyqlx: item.kyqlx, hits: item.hits, zyl: item.zyl, hzyx: item.hzyx, pic: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        this.swiperGroupList = tempList
      })
    },
    // 根据搜索条件获取数据
    search(arr)  //val 项目类别   val2 矿产种类   val3 合作方式   val4 国家   val5 输入关键词
    {
      //筛选条件
      let exp = ''
      if (arr[0] !== '')
        exp += `A.title like '%${arr[0]}%' and A.examine = 0 and `
      if (arr[1] !== '')
        exp += `A.catid = '${arr[1]}' and `
      exp = exp ? `${exp}A.id != 0` : 'A.id>0'

      let paras = {cmd: 'queryUnion', _major: 11, _minor: 129, tables: 'A;B:99,20', cols: 'A:*;B:dispc', _exp: exp + ' and A.catid=B.id', init: 0, pageno: 1, pagesize: 100, orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.projectsList = ret[0].data
        this.moreLength = this.projectsList.length
        // 初始化页面数据
        this.items = []
        if (this.projectsList.length >= 10)
        {
          for (let i = 0; i < 10; i++)
          {
            this.items.push(this.projectsList[i])
            this.moreLength -= 1
          }
        }
        else
        {
          for (let i = 0; i < this.projectsList.length; i++)
          {
            this.items.push(this.projectsList[i])
            this.moreLength -= 1
          }
        }
        this.num = 0
      })
    },
    // 加载更多
    getOthers()
    {
      this.num += 1
      if (this.projectsList.length - 10 * this.num >= 10)
      {
        for (let i = 0; i < 10; i++)
        {
          this.items.push(this.projectsList[i + 10 * this.num])
          this.moreLength -= 1
        }
      }
      else
      {
        for (let i = 0; i < this.projectsList.length - 10 * this.num; i++)
        {
          this.items.push(this.projectsList[i + 10 * this.num])
          this.moreLength -= 1
        }
      }
    },
    // 跳转到合作项目的详细信息页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyqtjDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    goDetailsP(item)
    {
      let url = this.$router.resolve({path: '/KyqtjDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyqtjList.vue